import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tri-state-switch',
  templateUrl: './tri-state-switch.component.html',
  styleUrl: './tri-state-switch.component.scss',
})
export class TriStateSwitchComponent {
  @Input()
  value: boolean | null = null;

  @Input()
  disabled: boolean = false;

  @Output() valueChange = new EventEmitter<boolean | null>();

  toggle(): void {
    var newValue = null;
    if (this.value == null) {
      newValue = false;
    } else if (this.value == true) {
      newValue = null;
    } else {
      newValue = true;
    }
    this.valueChange.emit(newValue);
  }
}
